import { Grid, Text, useTheme } from '@simplywallst/ui-core';

import LockSolid from '@simplywallst/ui-core/icons/LockSolid';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { pluralise } from '@/utilities/pluralise';

type Props = {
  label: string;
  $selected: boolean;
  excludedHoldingsCount?: null | number;
  holdingsCount?: null | number;
  totalHoldingsCount?: number;
  isPortfolioLimited?: boolean;
};

export const Option = ({
  label,
  $selected,
  excludedHoldingsCount,
  holdingsCount,
  totalHoldingsCount,
  isPortfolioLimited,
}: Props) => {
  const theme = useTheme();
  return (
    <Grid templateColumns="36px auto" gap="8px" alignItems="start">
      <Grid minHeight="36px" minWidth="36px" justifyContent="end">
        {$selected && (
          <CheckSolid height="28" width="28" fill={theme.color.chart01} />
        )}
      </Grid>
      <Grid
        templateColumns="auto 24px"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <Text
            typography="xSmall"
            color="phantom"
            textAlign="left"
            isTruncated
          >
            {label}
          </Text>
          <Text
            typography="tiny"
            color="darkGrayRGBA"
            opacity={isPortfolioLimited ? 0.6 : 1}
            textAlign="left"
          >
            {!isPortfolioLimited &&
            excludedHoldingsCount &&
            excludedHoldingsCount > 0
              ? `${holdingsCount} ${pluralise(
                  holdingsCount,
                  'holding',
                  'holdings'
                )}, ${excludedHoldingsCount} excluded`
              : `${totalHoldingsCount} ${pluralise(
                  totalHoldingsCount,
                  'holding',
                  'holdings'
                )}`}
          </Text>
        </div>
        {isPortfolioLimited ? (
          <LockSolid
            aria-label="Blocked Portfolio"
            fill={theme.color.chart05}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};
